import Component from './Tooltip.vue';

export default {
  install(Vue) {
    Vue.component('BkfTooltip', Component);
  },
};
